import { render, staticRenderFns } from "./LotteryPrizes.vue?vue&type=template&id=215a87f2&scoped=true&"
import script from "./LotteryPrizes.vue?vue&type=script&lang=ts&"
export * from "./LotteryPrizes.vue?vue&type=script&lang=ts&"
import style0 from "./LotteryPrizes.vue?vue&type=style&index=0&id=215a87f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a87f2",
  null
  
)

export default component.exports